export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number, public details?: unknown) {
    super(message);
  }
}

type RequestOptions = RequestInit & { token?: string | null };

async function request<T>(path: string, options: RequestOptions = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (options.token) headers.set("Authorization", `Bearer ${options.token}`);
  const response = await fetch(`/api/v1${path}`, { ...options, headers });
  if (response.status === 204) return undefined as T;
  const payload = await response.json().catch(() => ({})) as { data?: T; error?: { code?: string; message?: string; details?: unknown } };
  if (!response.ok) throw new ApiError(payload.error?.code || "REQUEST_FAILED", payload.error?.message || "请求失败", response.status, payload.error?.details);
  return payload.data as T;
}

export const api = {
  get: <T>(path: string, token?: string | null) => request<T>(path, { token }),
  post: <T>(path: string, body?: unknown, token?: string | null) => request<T>(path, {
    method: "POST", body: body === undefined ? undefined : JSON.stringify(body), token,
  }),
  put: <T>(path: string, body: unknown, token?: string | null) => request<T>(path, {
    method: "PUT", body: JSON.stringify(body), token,
  }),
  patch: <T>(path: string, body: unknown, token?: string | null) => request<T>(path, {
    method: "PATCH", body: JSON.stringify(body), token,
  }),
  delete: <T>(path: string, token?: string | null) => request<T>(path, { method: "DELETE", token }),
  upload: <T>(file: File, purpose: string, token: string, journeyId?: string) => {
    const form = new FormData();
    form.set("file", file); form.set("purpose", purpose); if (journeyId) form.set("journeyId", journeyId);
    return request<T>("/media", { method: "POST", body: form, token });
  },
  mediaUrl: (id: string, token: string) => `/api/v1/media/${encodeURIComponent(id)}?access_token=${encodeURIComponent(token)}`,
};
